import { createFileRoute, redirect } from '@tanstack/react-router';

/** Caminho antigo: Usuarios e acessos mora em /configuracoes/usuarios (o search vai junto). */
export const Route = createFileRoute('/_app/cadastros/usuarios')({
  beforeLoad: () => {
    throw redirect({ to: '/configuracoes/usuarios', search: true, replace: true });
  },
});
